var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"checkout-topnav",attrs:{"type":"button"},on:{"click":_vm.buttonCallback}},[_c('i',{staticClass:"icon-arrow-left",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.buttonText)))])])}
var staticRenderFns = []

export { render, staticRenderFns }